import { NavLink } from 'react-router-dom'
import { Home, Star, Link2, Trophy, Wallet } from 'lucide-react'
import { cn } from '@/lib/utils'

// P0.23 (22/08/2026, rediseño Mini App -- Sección 0/2 del encargo): navegación inferior =
// exactamente los 5 destinos del mockup visual maestro aprobado ("MENÚ NAVEGACIÓN": Inicio /
// Picks / Parlays / Reto / Banca). Same Game Parlay vive DENTRO de Parlays (el propio mockup
// lo describe así: "Parlays: 3 estrategias + Same Game Parlay"), Marcadores Probables y
// Resultado Exacto se acceden desde Inicio/el menú "Más" (icono en `AppHeader`) -- ninguna
// categoría se pierde, solo se reorganiza para no superar 5 botones permanentes (Sección 2:
// "No quiero 12 botones permanentes abajo").
const ITEMS = [
  { to: '/', label: 'Inicio', icon: Home, end: true },
  { to: '/picks', label: 'Picks', icon: Star },
  { to: '/parlays', label: 'Parlays', icon: Link2 },
  { to: '/reto', label: 'Reto', icon: Trophy },
  { to: '/banca', label: 'Banca', icon: Wallet },
]

// P0.53 (29/08/2026, Sección 9 del encargo): en desktop la navegación vive en `DesktopNav`
// (sidebar lateral) -- esta barra inferior se oculta a partir del breakpoint `md` para no
// duplicar la navegación. Mismas rutas/permisos en los dos casos, solo cambia la presentación.
export function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-20 bg-panel border-t border-border md:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex items-stretch justify-around">
        {ITEMS.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center justify-center gap-1 py-2.5 flex-1 text-[11px] font-medium transition-colors',
                isActive ? 'text-accent' : 'text-text-dim'
              )
            }
          >
            <Icon className="h-5 w-5" />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
